module.exports = __webpack_public_path__ + "static/img/bin.ebe4bb17.png";